module.exports = __webpack_public_path__ + "img/vip-arrow-left.dcfce416.png";